module.exports = __webpack_public_path__ + "src/img/notifyIcon.83d3dd1c.svg";